Hop.defineModule('freevsemployee-prewrite', () => {
    const url = new Url(window.location.href);

    if (url.query['JOB']) {
        $('#signupModal').modal('show');
        $('#signuplink').attr('data-ga-signup', 'vs-employee');
        Hop.getStoreObj('connectControl').tag = $('#signuplink');
        if (url.query['EMAIL']) {
            $('#signup_username').val(url.query['EMAIL']);
        }
    }
});
